import { animate, state, style, transition, trigger } from '@angular/animations'
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core'

import {
  CLOSED,
  FILTERS_COLLAPSED,
  FILTERS_EXPANDED,
  OPEN,
  SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
} from '../../../constants/constant.content'
import { ObservableService } from '../../services/observable-service/observable.service'
import { FilterModel } from '../../shared/filter-model'

@Component({
  selector: 'fd3-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  animations: [
    trigger('hightGrow', [
      state(
        'closed',
        style({
          height: '{{height}}px',
        }),
        { params: { height: '0' } },
      ),
      state(
        'open',
        style({
          height: '{{expandedHeight}}px',
        }),
        { params: { expandedHeight: '100%' } },
      ),
      transition('* => *', animate('180ms')),
    ]),
  ],
})
export class FiltersComponent implements OnInit, AfterViewInit {
  filter: any
  showFilters = false
  currentState = CLOSED
  divHeight!: number
  fd3ContentGenericListResponse: string
  fd3ContentFiltersListResponse: string
  filtersExpanded = FILTERS_EXPANDED
  filtersCollapsed = FILTERS_COLLAPSED
  filterByLabel: string
  @ViewChild('filtersPanel') filtersPanel!: ElementRef
  @ViewChild('searchContainer', { static: false }) searchContainer: ElementRef

  constructor(
    private filterModel: FilterModel,
    private readonly observableService: ObservableService,
  ) {}
  ngOnInit(): void {
    const aemCassDataFromSession = sessionStorage.getItem(
      SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
    )
    const parsedCaasJson = JSON.parse(aemCassDataFromSession)
    this.fd3ContentGenericListResponse =
      parsedCaasJson.data.fd3genericList.items[0]
    this.fd3ContentFiltersListResponse =
      parsedCaasJson.data.fd3filtersList.items[0]
    this.filterModel.telecastFilterBy.subscribe((data) => {
      this.filter = data
    })
    this.filterByLabel = this.fd3ContentFiltersListResponse['filterBy']
  }

  ngAfterViewInit(): void {
    const searchInputElem =
      this.searchContainer.nativeElement.querySelector('#fund-search-input')

    if (searchInputElem) {
      searchInputElem.setAttribute('data-rpa-tag-id', 'searchFundInput')
    }
  }

  openFilters() {
    this.showFilters = !this.showFilters
    this.divHeight = this.filtersPanel.nativeElement.clientHeight
    this.currentState = this.currentState === CLOSED ? OPEN : CLOSED
  }
  clearAllFilter() {
    this.filterModel.clearAllFilter()
  }

  searchFunds() {
    return (event: any) => {
      const searchText = event.searchTerm
      this.observableService.changeSearchSelection(searchText)
    }
  }
}
